module.exports = __webpack_public_path__ + "img/ASO_fr13.6c90fdf4.png";